// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__1JhL_","empty":"ModalGraph_empty__3Ourl"};